import { FILTER_CONFIG_NAMES } from './DataConstants';
import { isBuyerOrInternalTech } from './AuthUtils';

export const getPMScheduleFilterConfig = ({
	filters,
	currentUser = null,
}: {
	filters: any;
	currentUser?: any;
}) => {
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		filters[FILTER_CONFIG_NAMES.ASSET],
		...(isBuyerOrInternalTech(currentUser) ? [filters[FILTER_CONFIG_NAMES.ASSET_TYPE]] : []),
		filters[FILTER_CONFIG_NAMES.PM_TEMPLATE],
		filters[FILTER_CONFIG_NAMES.PROBLEM_TYPE],
	].filter(Boolean);
};
